import React, { useEffect, useState, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Lottie from 'react-lottie';
import animationData1 from '../lottie/bitcoin-investment-profit.json'
import animationData2 from '../lottie/bitcoin-profit-celebration.json'
import animationData3 from '../lottie/bitcoin-investment-loss.json'
import { toast, ToastContainer } from "react-toastify";
import API from "../utils/apiCalling";
import moment from "moment";
import Multiselect from 'multiselect-react-dropdown';
import Modal from "react-bootstrap/Modal";
import swal from "sweetalert";
import Config from "../config/env";
import Loader from '../utils/loader';
import { Button, Select, Form, Input, TextArea } from 'antd';
import { capitalizeFirstLetter } from "../utils/CommonFunction";
import { TumblrShareButton } from "react-share";
import { getNameById } from "../utils/CommonFunction";
function Admindash() {
  const onFinish = (values) => {
  };
  const showToast = (use) => {
    if (use == 'upgrade') {
      toast.success('To Use This Feature,Kindly Upgrade Your Package', {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }
  let userData = JSON.parse(localStorage.getItem("user"));
  let api = new API();
  const [form] = Form.useForm();
  const buttonRef = useRef(null);
  const closeModel = useRef(null);
  const closeModel2 = useRef(null);
  const templatePopup = useRef(null);
  const surveyPopup = useRef(null);
  const search = useLocation().search;
  const [audio, setAudio] = useState(false)
  const history = new useHistory();
  const [divClass, setDivClass] = useState(" ");
  const [divId, setDivId] = useState("sidebar");
  const [surveyTitle, setSurveyTitle] = useState();
  // const [userData, setUserData] = useState(localStorage.getItem("user"));
  const [plan_days, setplanDays] = useState(0)
  const [surveyType, setSurveyType] = useState("Digital Surveys (CAWI)");
  const [exCompletes, setExCompletes] = useState('');
  const [exIncidence, setExIncidence] = useState();
  const [url, setUrl] = useState()
  const [exLOI, setExLOI] = useState();
  const [surveyCategoru, setSurveyCategory] = useState();
  const [audience, setAudience] = useState();
  const [addSurveyCategory, setAddSurveyCategory] = useState("");
  const [surveycategory, setSurveycategory] = useState();
  const [filteredCategory, setFilteredCategory] = useState([]);
  const [Suvrey, setSuvrey] = useState([]);
  const [surveyfilter, setSurveuFilter] = useState([]);
  const [grid, setGrid] = useState(1);
  // const[list,setList]=useState(1)
  const [Workspace, setWorkSpace] = useState([]);
  const [active, setactive] = useState(true);
  const [stage, setStage] = useState();
  const [survCat, setSurvCat] = useState(false)
  const [notifications, setNotifications] = useState([]);
  const [notifyCount, setNotifyCount] = useState(0);
  const [loader2, setLoader2] = useState(true)
  const [userBasicDetails, setUserBasicDetails] = useState([])
  const [categoryId, setCategoryId] = useState()
  const [pagination, setPagination] = useState();
  const [pageCount, setPageCount] = useState(0);
  const [loader, setLoader] = useState(false)
  const [movetoCategory, setMovetoCategoryto] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState()
  const [SuvreyId, setSuvreyId] = useState();
  const [finalSelectedCategory, setFinalSelectedCategory] = useState('')
  // let getUser_Id = JSON.parse(localStorage.getItem("user"))?.user_role==="member"?;
  const setMovetoCategory = (e) => {
    // moveSurvey(e);
    setMovetoCategoryto(e);
  }
  let date = [new Date().getFullYear(), new Date().getMonth() + 1, new Date().getDay()]
  const [demoData, setDemoData] = useState({
    time: "",
    date: "",
    description: "",
    mobile: "",
    email: ""
  });
  const [access, setAccess] = useState({});
  const toggleIsLoading = (value, index) => {
    setAddSurveyCategory(value)
    setCategoryIndex(index)
    setSurvCat(true);
  };
  const setAudienceHandle = (id) => {
    setAudience(id);
    if (id === "Buy Audience") {
      setactive(false);
    } else if (id === "My Own Audience") {
      setactive(true);
      // setExCompletes();
      setExIncidence();
      // setExLOI('');
    }
  };
  const moveSurvey = async (a) => {
    let payLoad = {
      Id: movetoCategory._id,
      category_id: selectedCategory,
    }
    let result = await api.post(`${Config.new.site_api}/client-survey/MoveToSurveyCategory`, payLoad)
  }
  const defaultOptions1 = {
    loop: true,
    autoplay: true,
    animationData: animationData1,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  const defaultOptions2 = {
    loop: true,
    autoplay: true,
    animationData: animationData2,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  const defaultOptions3 = {
    loop: true,
    autoplay: true,
    animationData: animationData3,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };
  // const[cEditedData,setCEditData]=useState()
  const [categoryName, setCategoryName] = useState();
  const [categoryIndex, setCategoryIndex] = useState();
  var [selectedLang, setSelectedLang] = useState([])
  const [lang, setLang] = useState([])
  const [language, setLanguage] = useState([]);
  const [surveyModal, setSurveyModal] = useState(false)
  const [adminButton, setAdminButton] = useState('')
  useEffect(() => {
    getNotifications(userData)
    getsueveyCategory(userData?._id);
    getAccess(userData?._id);
    getLanguage();
    userData.userType === "admin"
      ? setAdminButton("admin")
      : setAdminButton("");
    // getSurveyByUserId("", 0)
  }, []);
  const closeSurveyModel = () => {
    closeModel2.current.click();
    closeModel.current.click();
  }
  const SelectLng = (e, mode) => {
    if (mode == "setData") {
      let options = e
      setSelectedLang(options)
    }
    else {
      let tem = []
      language.forEach(l => {
        if (selectedLang.includes(l.lang_name)) {
          tem.push(l)
        }
      })
      return tem
    }
  }
  const getLanguage = async (e) => {
    setLoader(true)
    const result = await api.post(`${Config.new.site_api}/survey/getLanguage`, {})
    if (result && result.code === 200) {
      setLanguage(result.data);
      let a = []
      result.data.forEach(ele => {
        a.push(ele.lang_name)
      })
      setLang(a)
    }
    setLoader(false)
  }
  const initials = (userData && (userData.firstName[0] + userData.lastName[0]).toUpperCase());
  const setdd = () => {
    setDemoData({ ...demoData, mobile: userData.mobile, email: userData.email })
  }
  const openModel = () => {
    buttonRef.current.click();
  };
  const handleSubmit = async (e) => {
    if (!demoData.date || !demoData.time || !userData.mobile || !demoData.email) {
      return;
    } else {
      let data = {
        user_id: userData?._id,
        time: demoData.time,
        description: demoData.description,
        date: demoData.date,
        name: userData.fullName,
        email: demoData.email,
        number: userData.mobile
        ,
      };
      setLoader(true)
      let result = await api.post(
        `${Config.new.site_api}/client-survey/addFreeDemo`,
        data
      );
      if (result.code === 200) {
        toast.success(result.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
        let emptyval = { Date: "", time: "", mobile: "", email: "", description: "" }
        setDemoData(emptyval)
      }
      setLoader(false)
    }
  };
  const getAccess = async (id) => {
    let data = {
      _id: id,
    };
    setLoader(true)
    let result = await api.post(
      `${Config.new.site_api}/client-survey/getPackages`,
      data
    );
    if (result?.code === 200) {
      setAccess(
        result.data && result.data[0] && result.data[0].package_details
          ? result.data[0].package_details
          : undefined
      );
      setplanDays(result.data && result.data[0] && result.data[0].package_details
        ? result.data[0].plan_days
        : undefined)
      if (result.data[0]?.plan_days === 0) {
        openModel()
      }
      setLoader(false)
    } else {
      toast.error(result?.message, {
        position: toast.POSITION.TOP_RIGHT,
      });
      setLoader(false)
    }
  };
  const filterCategory = (value) => {
    let temp = [];
    surveycategory.forEach((element) => {
      if (element.category.match(value)) temp.push(element);
    });
    setFilteredCategory(temp);
  };
  const navigateToTemplate = () => {
    templatePopup.current.click()
    history.push('/SurveyTemplates')
  }

  const editDelete = async (type, data1, newData) => {
    setSurvCat(!survCat)
    let tempCategory = [...filteredCategory];
    if (type === "edit") {
      tempCategory[data1].category = addSurveyCategory ? addSurveyCategory : ""
    }
    let data = {
      user_id: tempCategory[data1].userId,
      _id: tempCategory[data1]._id,
      category_name: tempCategory[data1].category,
      option: type,
    };

    setLoader(true)
    let result = await api.post(
      `${Config.new.site_api}/client-survey/editSurveyCategory`,
      data
    );
    if (result.code === 200) {
      setSurveycategory(tempCategory);
      setFilteredCategory(tempCategory);
      setCategoryName("");
      getsueveyCategory(userData._id);
      toast.success(result.message, {
        position: toast.POSITION.TOP_RIGHT,
      });
      setCategoryIndex();
      setLoader(false)
    } else {
      toast.error(result.message, {
        position: toast.POSITION.TOP_RIGHT,
      });
      setLoader(false)
    }
  };
  const toggleEditDelete = (type, index) => {
    setCategoryIndex(index);
    setCategoryName(surveycategory && surveycategory[index].category);
    setAddSurveyCategory(type.category)
  };
  const SelectCategory = (id) => {
    setPageCount(0)
    filteredCategory.forEach(el => {
      if (el._id == id) {
        setStage(el)
        setCategoryId(el)
      }
    })
    getSurveyByUserId(id);
  };
  const sendPageCount = (value) => {
    // if (value === 'back') {
    //   setPageCount(pageCount - 1)
    //   getSurveyByUserId(categoryId, pageCount - 1);
    // }
    // if (value === 'next') {
    //   setPageCount(pageCount + 1)
    //   getSurveyByUserId(categoryId, pageCount + 1);
    // }
    let newPageCount = value === 'back' ? pageCount - 1 : pageCount + 1;
    setPageCount(newPageCount);
    getSurveyByUserId(categoryId ? categoryId._id : null, newPageCount);
  }
  // const getCategoryById = async (id) => {
  //   let data = {
  //     Id: id,
  //   };
  //   setLoader(true)
  //   let result = await api.post(
  //     `${Config.new.site_api}/client-survey/getSurveyCategory`,
  //     data
  //   );
  //   if (result?.code === 200) {
  //     setSurveyCategory(result.data[0]._id)
  //     setWorkSpace(result.data);

  //   }
  //   setLoader(false)
  // };
  const changeclassname = () => {
    if (divId === "sidebar" && divClass === " ") {
      setDivClass("handleClassNameAndId");
      setDivId(" ");
    } else {
      setDivClass(" ");
      setDivId("sidebar");
    }
  };
  const addDasgboard = async (Duplicate) => {
    let result
    if (Duplicate !== undefined) {
      setLoader(true)
      delete Duplicate._id
      Duplicate.survey_name = Duplicate.survey_name + '(Duplicate)'
      result = await api.post(
        `${Config.new.site_api}/client-survey/createNewSurvey`,
        { survey: JSON.stringify(Duplicate) }
      );
    } else {
      let data = {
        survey_name: surveyTitle,
        User_Id: userData._id,
        survey_id: "",
        points: "",
        status: "Active",
        survey_type: "open",
        createdBy: "",
        is_shareable: "",
        languages: SelectLng([], "update"),
        response_Limit: exCompletes,
        Incidence: exIncidence,
        Loi: exLOI,
        audio: audio,
        category_id: surveyCategoru,
        audience: audience,
      };
      setLoader(true)
      result = await api.post(
        `${Config.new.site_api}/client-survey/createNewSurvey`,
        { survey: JSON.stringify(data) }
      );
    }
    if (result.code === 200) {
      form.setFieldsValue({})
      toast.success("Survey Added Successfully", {
        position: toast.POSITION.TOP_RIGHT,
      })
      closeSurveyModel()
      localStorage.setItem("survey", JSON.stringify(result.data));
      SetSuvrey(result.data._id);
      // return history.push('/createSurvey')
      setLoader(false)
    }
  }
  const addDasgboardClient = async () => {
    let data = {
      survey_name: surveyTitle,
      User_Id: userData._id,
      is_client: 1,
      url: url,
      Loi: exLOI,
      category_id: surveyCategoru,
      survey_id: "",
      points: "",
      status: "Active",
      survey_type: "open",
      createdBy: "",
      is_shareable: "",
    }
    try {
      let result = await api.post(`${Config.new.site_api}/client-survey/createNewSurvey`, { survey: JSON.stringify(data) })
      if (result.code === 200) {
        toast.success("Survey Added Successfully", {
          position: toast.POSITION.TOP_RIGHT,
        })
        closeSurveyModel()
        // localStorage.setItem("survey", JSON.stringify(result.data));
        // SetSuvrey(result.data._id) ;
        // setLoader(false)
      }
    } catch (error) {
      console.log("Hell Error", error)
    }
  }
  const parentToChild = () => {
    history.push(`/Demoreport/`);
  };
  const addsurveyCategory = async () => {
    if (addSurveyCategory !== "" && addSurveyCategory !== undefined) {
      let data = {
        userId: userData?._id,
        category: addSurveyCategory,
      };
      setLoader(true)
      let result = await api.post(
        `${Config.new.site_api}/client-survey/addsurveyCategory`,
        data
      );
      if (result.code === 200) {
        getsueveyCategory(userData?._id);
        setAddSurveyCategory("");
        toast.success(result.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setLoader(false)
      } else {
        toast.error(result.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setLoader(false)
      }
    } else {
      toast.error("Please Enter Survey Category name", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };
  const getsueveyCategory = async (id) => {
    let data = {
      userId: id,
    };
    setLoader(true)
    let result = await api.post(
      `${Config.new.site_api}/client-survey/getSurveyCategory`,
      data
    );
    if (result?.code === 200) {
      let categories = result.data.sort((a, b) => a.category.localeCompare(b.category))
      setSurveycategory(categories);
      let data = {
        category: "All Categories",
        _id: ""
      }
      let temp = [data]
      categories.forEach((item) => {
        temp.push(item)
      })
      setStage(data)
      setFilteredCategory(temp);
      getSurveyByUserId(data._id, 0);
      setLoader(false)
    }
  };
  const SetSuvrey = (value) => {
    history.push(`/createSurvey/${value}`);
  };
  const getSurveyByUserId = async (id, count) => {
    let data = {};
    if (id && id !== "") {
      data = {
        category_id: id,
        pageNumber: count,
        pageSize: 9
      };
    } else {
      data = {
        User_Id: userData?._id,
        pageNumber: count,
        pageSize: 9
      };
    }
    setLoader(true)
    let result = await api.post(
      `${Config.new.site_api}/client-survey/getSurvey`,
      data
    );
    if (result.code === 200) {
      setSuvrey(result.data);
      setSurveuFilter(result.data);
      setLoader2(false)
      setUserBasicDetails(result.data)
      setPagination(result.countTotal)
      setLoader(false)
    } else {
      setLoader(false)
      setSuvrey([]);
    }
  };
  const SetActive = (id) => {
    if (id === "complete") {
      setSuvrey(surveyfilter.filter((e) => e.response_Limit === 0));
    } else {
      setSuvrey(surveyfilter.filter((e) => e.status === id));
    }
  };
  const CreatedDate = (Id) => {
    setSuvrey(surveyfilter.filter((e) => e.date.split("T")[0] === Id));
  };
  const changeSurveyStatus = async (data, index) => {
    let temp = [...Suvrey];
    temp[index].status = data.status;
    data.survey_name = temp[index].survey_name
    data.fullName = userData.fullName
    setLoader(true)
    let result = await api.post(
      `${Config.new.site_api}/admin-dashboard/activeInactiveSurvey`,
      data
    );
    if (result?.code === 200) {
      setSuvrey(temp);
      toast.success(
        `${temp[index].survey_name} survey ${data.status == "active"
          ? "started"
          : data.status == "inactive"
            ? "Paused"
            : "Completed"
        }`,
        {
          position: toast.POSITION.TOP_RIGHT,
        }
      );
      setLoader(false)
    } else {
      toast.error(result?.message, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
    setLoader(false)
  };
  const deleteSurvey = async (e, index) => {
    let data = {
      id: e
    }
    setLoader(true)
    let result = await api.get(`${Config.new.site_api}/client-survey/deleteSurvey`, true, data)
    if (result?.code === 200) {
      let temp = []
      temp = [...Suvrey]
      temp.splice(index, 1);
      Suvrey.push(temp)
      setSuvrey(temp)
      toast.success(result.message, {
        position: toast.POSITION.TOP_RIGHT,
      });
      setLoader(false)
    }
  }
  const Upgrade = () => {
    history.push("/plan");
  };
  const logOut = () => {
    swal({
      // html: true,
      title: "Are you sure to LogOut?",
      // text: ``,
      // icon: "",
      buttons: ["No, cancel it!", "Yes"],
      dangerMode: true,
    }).then(async function (isConfirm) {
      if (isConfirm) {
        localStorage.clear();
        history.push("/login");
      }
    });
  };
  const getNotifications = async (userData) => {
    let body = {
      user_id: userData._id,
      page: 1,
      limit: 25,
    };
    setLoader(true)
    let result = await api.post(
      `${Config.new.site_api}/common/notificationList`,
      body
    );
    if (result?.code === 200) {
      setNotifications(result.data.notifications);
      setLoader(false)
    } else {
      toast.error(result?.message);
      setLoader(false)
    }
    let input = {
      user_id: userData._id,
    };
    setLoader(true)
    let res = await api.post(
      `${Config.new.site_api}/common/totalUnReadCount`,
      input
    );
    if (res?.code === 200) {
      setNotifyCount(res.data.unread_notifications_count);
      setLoader(false)
    } else {
      toast.error(res?.message);
      setLoader(false)
    }
  };
  const readNotification = async (_id) => {
    let data = {
      notification_id: _id,
    };
    setLoader(true)
    let res = await api.post(
      `${Config.new.site_api}/common/notificationReadApi`,
      data
    );
    if (res.code === 200) {
      setLoader(false)
    }
    setLoader(false)
  };
  const fgd = () => {
    history.push('/Fgd')
    surveyPopup.current.click()
  }
  const editSurveyDetails = (e) => {
    // getCategoryById(e.category_id)
    setSuvreyId((e?._id) ? e?._id : "")
    setSurveyCategory((e?.category_id) ? e?.category_id : "")
    form.setFieldsValue({
      surveyname: e.survey_name,
      expectedcompletes: e.response_Limit,
      surveyaudience: e.audience,
      expectedcompletionloi: e.Loi,
      expectedincidencerate: e?.Incidence,
      surveycategory: e.category_id
    });
    setSurveyTitle(e?.survey_name)
    setExCompletes(e?.response_Limit)
    setAudience((e?.audience) ? e?.audience : "")
    setExLOI(e?.Loi)
    // setExIncidence()
  }

  const closeValue = () => {
    setDemoData({
      description: "",
    });
    form.resetFields();
  }



  const formRef = useRef();


  const closeButton = () => {
    setExCompletes("")
    setSurveyTitle("")
    formRef.current.resetFields();
  }
  

  return (
    <>
      {loader && <Loader />}
      <div
        className="modal fade"
        id="demoThisVart"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header align-items-center">
              <h1 className="modal-title m-0 text-orange" id="exampleModalLabel">
                Schedule a Demo
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeValue}
              ></button>
            </div>
            <div className="modal-body">
              <Form form={form}
                name="normal_login"
                className="login-form "
                initialValues={{ remember: true }}
                onFinish={onFinish}>
                <div className="row dattimesha">
                  <div className="col-md-6  site-form-item-icon">
                    <label htmlFor="birthday" className="fw-4 text-blue">
                      {" "}
                      Preferred Date :
                    </label>
                    <Form.Item
                      name="preferreddate"
                      rules={[{ required: true, message: 'Please input your preferred date!' }]}>
                      <Input
                        type="date"
                        id="Demo"
                        className="mb-3 site-form-item-icon"
                        value={demoData.date}
                        min={new Date().toJSON().slice(0, 10)}
                        onChange={(e) =>
                          setDemoData({ ...demoData, date: e.target.value })
                        }
                      />
                    </Form.Item>
                  </div>
                  <div className="col-md-6">
                    <label htmlFor="birthday" className="fw-4 text-blue site-form-item-icon">
                      {" "}
                      Preferred Time :
                    </label>
                    <Form.Item
                      name="preferredtime"
                      rules={[{ required: true, message: 'Please input your preferred time!' }]}>
                      <Input
                        type="time"
                        className="mb-3 site-form-item-icon"
                        id="Demo"
                        name="time"
                        value={demoData.time}
                        onChange={(e) =>
                          setDemoData({ ...demoData, time: e.target.value })
                        }
                      />
                    </Form.Item>
                  </div>
                  <div className="col-md-6 site-form-item-icon">
                    <label htmlFor="birthday" className="fw-4 text-blue">
                      Number:
                    </label>
                    <Form.Item name="usermobile"
                      rules={[{ required: true, message: 'Please input your mobile no.!' }]}>
                      <Input
                        type="text"
                        id="Demo"
                        className="form-control mb-3 site-form-item-icon"
                        maxLength={10}
                        name="mobile"
                        style={{ width: "100%", height: "40px" }}
                        value={demoData.mobile}
                        onChange={(e) =>
                          setDemoData({ ...demoData, mobile: e.target.value })
                        }
                      />
                    </Form.Item>
                  </div>
                  <div className="col-md-6 site-form-item-icon">
                    <label htmlFor="birthday" className="fw-4 text-blue">
                      Email:
                    </label>
                    <Form.Item
                      name="useremail"
                      rules={[{
                        type: 'email', message: 'The input is not valid E-mail!',
                      }, {
                        required: true, message: 'Please input your E-mail!',
                      }]}>
                      <Input
                        type="email"
                        id="Demo"
                        className="form-control mb-3 site-form-item-icon"
                        name="mobile"
                        style={{ width: "100%", height: "40px" }}
                        value={demoData.email}
                        onChange={(e) =>
                          setDemoData({ ...demoData, email: e.target.value })
                        }
                      />
                    </Form.Item>
                  </div>
                  <div className="col-md-12 site-form-item-icon">
                    <label htmlFor="exampleFormControlTextarea1" className="form-label">
                      <p className="text-blue mb-0"> Description :</p>
                    </label>
                    <Form.Item   >
                      <Input.TextArea
                        className="form-control mb-3 site-form-item-icon"
                        id="exampleFormControlTextarea1"
                        rows="2"
                        value={demoData.description}
                        name="description"
                        maxLength={100}
                        onChange={(e) =>
                          setDemoData({ ...demoData, description: e.target.value })
                        }
                      ></Input.TextArea>
                    </Form.Item>
                    {/* <Form.Item>
            <button
                className="mainbtn"
                type="submit"
                // data-bs-dismiss="modal"
                // aria-label="Close"
                autoClose
                onClick={(e) => handleSubmit()}
              >
                Submit
              </button>
            </Form.Item> */}
                    <Form.Item >
                      <Button
                        type="submit" htmlType="submit"
                        className="mainbtn text-white login-form-button" onClick={(e) => handleSubmit()} >
                        Submit
                      </Button>
                    </Form.Item>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
      <section id="all-section" className="admin-header">
        <nav className="navbar navbar-expand-lg nevigtsao bg-white p-0 border border-bottom">
          <div className="container-fluid p-0">
            <div className="d-flex justify-content-between w-100 mancolapsefirst my-2">
              <div className="d-flex align-items-center justify-content-between mancolapse pr-3">
                <div className="d-flex align-items-center navNewVi px-3">
                  <a className="navbar-brand1 me-3">
                    <img src="../images/new-logo.png" width="95px" alt="" />
                  </a>
                  {plan_days < "10" && (
                    <><h4 className="headerheading">
                      Your free trial is ending in{" "}
                      <span className="text-orange">{plan_days} days</span>
                    </h4>
                      {/* <img src={'../images/alarm.gif'} width="1%" className="pb-3" /> */}
                    </>
                  )}
                </div>
                <div className="d-flex nvbrdLabek">
                  <a
                    id="dLabel"
                    role="button"
                    className="nav-link dropdown-toggle"
                    href="#"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="bi bi-bell-fill text-blue fs-4 position-relative">
                      <span className="position-absolute top-0 start-100 translate-middle badge rounded-circle text-blue f-12 bg-grey">
                        <small className="fw-bold">{notifyCount}</small>
                        <span className="visually-hidden">unread messages</span>
                      </span>
                    </i>
                  </a>
                  <button className="navbar-toggler catagorymn px-2" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"><i className="bi bi-list"></i></span>
                  </button>
                </div>
              </div>
              <div className="collapse navbar-collapse justify-content-end" id="navbarNavDropdown">
                <ul className="navbar-nav flex-row">
                  <div className="nav-item dropdown notification-drop flex-wrap navNewBi">
                    {plan_days < "10" && (
                      <><h4 className="headerheading">
                        Your free trial is ending in{" "}
                        <span className="text-orange">{plan_days} days</span>
                      </h4>
                        {/* <img src={'../images/alarm.gif'} width="1%" className="pb-3" /> */}
                      </>
                    )}
                    {/* <br /> */}
                    <div className="d-flex gap-3 align-items-center">
                      {(userData?.plan_id !== "6454f0f50b562924b060226d") ? <button
                        type="button"
                        className="mainbtn mainheadbtun visbBUtton border-1 d-flex align-items-center upgradebtn"
                        style={{
                          height: "35px",
                          border: "1px solid #f47321",
                          color: "#f47321",
                          background: "#fff",
                        }}
                        onClick={(e) => Upgrade()}
                      >
                        <img
                          src="../images/crown.svg"
                          className="me-2"
                          width="20px"
                          alt=""
                        />
                        Upgrade
                      </button> : ""}
                      <button
                        type="button"
                        className="mainbtnblue mainheadbtun d-flex align-items-center"
                        data-bs-toggle="modal"
                        onClick={() => setdd()}
                        data-bs-target="#demoThisVart"
                        style={{ height: "37px" }}
                      >
                        Request a Free Demo
                      </button>
                    </div>
                    <a
                      id="dLabel"
                      role="button"
                      className="nav-link dropdown-toggle"
                      href="#"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i className="bi bi-bell-fill text-blue fs-4 position-relative">
                        <span className="position-absolute top-0 start-100 translate-middle badge rounded-circle text-blue f-12 bg-grey">
                          <small className="fw-bold">{notifyCount}</small>
                          <span className="visually-hidden">unread messages</span>
                        </span>
                      </i>
                    </a>
                    <ul
                      className="dropdown-menu dropdown-menu-lg-end notifications"
                      role="menu"
                      aria-labelledby="dLabel"
                    >
                      <div className="notification-heading">
                        <p className="text-orange m-2 f-14">Notifications</p>
                      </div>
                      <li className="divider" />
                      <div className="notifications-wrapper">
                        {notifications.length &&
                          notifications.map((notify, index) => (
                            <a className="content" key={index}>
                              {notify.read_status == 1 && (
                                <div
                                  className="notification-item  unread"
                                >
                                  <img src="../images/2.png"></img>
                                  <div className="tableform w-100">
                                    <p className="text-orange f-14">
                                      {notify.title}
                                      <span className="float-right f-12">
                                        {(JSON.stringify(date) == JSON.stringify([new Date(notify.created_at).getFullYear(), new Date(notify.created_at).getMonth() + 1, new Date(notify.created_at).getDay()])) ? new Date(new Date(notify.created_at) * 1000).toLocaleTimeString() : moment(notify.created_at).format('DD/MM/YY')}
                                      </span>
                                    </p>
                                    <p className="item-info f-12">
                                      {notify.message}
                                    </p>
                                  </div>
                                </div>
                              )}
                              {notify.read_status == 0 && (
                                <div
                                  onClick={() => readNotification(notify._id)}
                                  className="notification-item  read"
                                >
                                  <img src="../images/woman.png"></img>
                                  <div className="tableform w-100">
                                    <p className="text-orange f-14">
                                      {notify.title}
                                      <span className="float-right f-12">
                                        {(JSON.stringify(date) == JSON.stringify([new Date(notify.created_at).getFullYear(), new Date(notify.created_at).getMonth() + 1, new Date(notify.created_at).getDay()])) ? new Date(new Date(notify.created_at) * 1000).toLocaleTimeString() : moment(notify.created_at).format('DD/MM/YY')}
                                      </span>
                                    </p>
                                    <p className="item-info f-12">
                                      {notify.message}
                                    </p>
                                  </div>
                                </div>
                              )}
                            </a>
                          ))}
                      </div>
                    </ul>
                  </div>
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link nav dropdown-toggle d-flex align-items-center"
                      href="#"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <div style={{ width: "46px" }}
                        className="rounded-circle" id="profileImage">{initials}</div>
                      {/* <p className="aname m-0 px-2 text-black">
                      {userData && userData.fullName}
                    </p> */}
                      <i className="text-black bi bi-chevron-down"></i>
                    </a>
                    <ul className="dropdown-menu dropdown-menu-lg-end position-absolute">
                      {/* <li><a className="dropdown-item" onClick={() => history.push('/panelistDash')} >Panelist DashBoard</a></li> */}
                      {adminButton === "admin" && (
                        <li>
                          <a
                            className="dropdown-item"
                            href="/#/192837465/adminDashboard"
                          >
                            Admin Dashboard
                          </a>
                        </li>
                      )}
                      <li>
                        <a className="dropdown-item" onClick={(e) => history.push("/ClientProfile")} >
                          My Profile
                        </a></li>
                      <li>
                        <a className="dropdown-item" onClick={(e) => history.push("/userManagement")} >
                          Our Team
                        </a>
                        <a className="dropdown-item" onClick={logOut} >
                          Logout
                        </a>


                      </li>
                      {/* <li><a className="dropdown-item" href="#">Something else here</a></li> */}
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
      </section>
      <section id="all-section" className="section-survey headerextraa">
        {/* Categories Small sc offcanvas */}
        <div className="offcanvas offcanvas-start" tabindex="-1" id="sidecnvs" aria-labelledby="offcanvasExampleLabel">
          <div className="offcanvas-header position-absolute w-100">
            <button type="button" className="btn-close position-absolute" data-bs-dismiss="offcanvas" aria-label="Close" style={{ bottom: "-17px", right: "14px" }}></button>
          </div>
          <div className="offcanvas-body offMantance overflow-hidden">
            <nav
              id={divId === "sidebar" ? "sidebar" : " "}
              className={
                divClass === "handleClassNameAndId"
                  ? "handleClassNameAndId"
                  : " "
              }
            >
              {/*{changeId}  onClick={handleId} */}
              <div className="search-container position-relative m-2">
                <button
                  type="button"
                  id="sidebarCollapse"
                  onClick={changeclassname}
                  className="btn border-0 text-blue searchNima"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={12}
                    height={12}
                    fill="white"
                    className="bi bi-arrow-left-right"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fillRule="evenodd"
                      d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5zm14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5z"
                    />
                  </svg>
                </button>
                <form className="bg-lgrey d-flex align-items-center">
                  <button type="submit" className="border-0">
                    <img
                      src="../images/Icon feather-search.svg"
                      alt=""
                      className="m-2 w-50"
                    />
                  </button>
                  <input
                    type="text"
                    placeholder="Find Category"
                    name="search"
                    className="bg-lgrey form-control"
                    onChange={(e) => filterCategory(e.target.value)}
                  />
                </form>
              </div>
              {/* details */}
              <div className="sidebar-details">
                <summary onClick={() => setAddSurveyCategory("")}>
                  <div
                    className="sidebar-btn mb-4  "
                    data-bs-toggle="modal"
                    data-bs-target="#category"
                  >
                    {/* <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="currentColor" className="bi bi-chevron-down" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
                          </svg> */}
                    <p className=" f-14 m-0 text-orange boldnormal-p">
                      Categories
                    </p>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={16}
                      height={16}
                      fill="currentColor"
                      className="bi bi-plus text-orange boldnormal-p"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                    </svg>
                  </div>
                </summary>
                <div className="sidebarBar">
                  {/* <div
                            className="f-14 d-flex siderTam justify-content-between align-items-center"
                            style={{ cursor: "Pointer" }}
                          >
                            <h6 onClick={(event) => SelectCategory("")}>
                              All Categories
                            </h6>
                            <p></p>
                          </div> */}
                  {filteredCategory &&
                    filteredCategory.map((ele, index) => {
                      return (
                        <>
                          <div
                            className="f-14 d-flex siderTam justify-content-between align-items-center"
                            style={{ cursor: "Pointer" }}
                          >
                            <h6 onClick={(event) => SelectCategory(ele._id)} className={stage._id == ele._id ? "digity active" : "digity"}>
                              {capitalizeFirstLetter(ele.category)}
                            </h6>
                            {ele._id !== "" &&
                              <div className="dropdown">
                                <button
                                  className="border-0 bg-white"
                                  type="button"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <i className="bi bi-three-dots-vertical"></i>
                                </button>
                                <ul className="dropsCateg dropdown-menu">
                                  <li>
                                    <a className="dropdown-item">
                                      <p
                                        className="p-0 m-0 text-orange"
                                        onClick={() =>
                                          toggleIsLoading(ele.category, index - 1)
                                        }
                                        data-bs-toggle="modal"
                                        data-bs-target="#category"
                                      >Edit</p>
                                    </a>
                                  </li>
                                  <li>
                                    <a className="dropdown-item" >
                                      <p
                                        className="p-0 m-0 text-orange"
                                        onClick={(e) =>
                                          editDelete("delete", index)
                                        }
                                      >Delete</p>
                                    </a>
                                  </li>
                                </ul>
                              </div>}
                            {/* <i className='fa fa-edit text-orange' onClick={() => toggleEditDelete(true, index)} ></i> &nbsp;
                                  <i className="fa fa-trash fa-lg text-orange" onClick={(e) => editDelete("delete", index)}></i> */}
                            <p></p>
                          </div>
                        </>
                      );
                    })}
                </div>
              </div>
              {/* details */}
            </nav>
          </div>
        </div>
        {/* Categories Small sc offcanvas */}
        <div className="container-fluid ">
          <div className="row ">
            <div className="wrapper sidOpera">
              {/* Sidebar  */}
              <nav
                id={divId === "sidebar" ? "sidebar" : " "}
                className={
                  divClass === "handleClassNameAndId"
                    ? "handleClassNameAndId"
                    : "com-bsl "
                }
              >
                {/*{changeId}  onClick={handleId} */}
                <div className="search-container position-relative m-2">
                  <button
                    type="button"
                    id="sidebarCollapse"
                    onClick={changeclassname}
                    className="btn border-0 text-blue searchNima"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={12}
                      height={12}
                      fill="white"
                      className="bi bi-arrow-left-right"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M1 11.5a.5.5 0 0 0 .5.5h11.793l-3.147 3.146a.5.5 0 0 0 .708.708l4-4a.5.5 0 0 0 0-.708l-4-4a.5.5 0 0 0-.708.708L13.293 11H1.5a.5.5 0 0 0-.5.5zm14-7a.5.5 0 0 1-.5.5H2.707l3.147 3.146a.5.5 0 1 1-.708.708l-4-4a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 4H14.5a.5.5 0 0 1 .5.5z"
                      />
                    </svg>
                  </button>
                  <form className="bg-lgrey d-flex align-items-center">
                    <button type="submit" className="border-0">
                      <img
                        src="../images/Icon feather-search.svg"
                        alt=""
                        className="m-2 w-50"
                      />
                    </button>
                    <input
                      type="text"
                      placeholder="Find Category"
                      name="search"
                      className="bg-lgrey form-control"
                      onChange={(e) => filterCategory(e.target.value)}
                    />
                  </form>
                </div>
                {/* details */}
                <div className="sidebar-details">
                  <summary onClick={() => setAddSurveyCategory("")}>
                    <div
                      className="sidebar-btn mb-4  "
                      data-bs-toggle="modal"
                      data-bs-target="#category"
                    >
                      {/* <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="currentColor" className="bi bi-chevron-down" viewBox="0 0 16 16">
                      <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
                    </svg> */}
                      <p className=" f-14 m-0 text-orange boldnormal-p">
                        Categories
                      </p>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={16}
                        height={16}
                        fill="currentColor"
                        className="bi bi-plus text-orange boldnormal-p"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                      </svg>
                    </div>
                  </summary>
                  <div className="sidebarBar">
                    {/* <div
                      className="f-14 d-flex siderTam justify-content-between align-items-center"
                      style={{ cursor: "Pointer" }}
                    >
                      <h6 onClick={(event) => SelectCategory("")}>
                        All Categories
                      </h6>
                      <p></p>
                    </div> */}
                    {filteredCategory &&
                      filteredCategory.map((ele, index) => {
                        return (
                          <>
                            <div
                              className="f-14 d-flex siderTam justify-content-between align-items-center"
                              style={{ cursor: "Pointer" }}
                            >
                              <h6 onClick={(event) => SelectCategory(ele._id)} className={stage._id == ele._id ? "digity active" : "digity"}>
                                {capitalizeFirstLetter(ele.category)}
                              </h6>
                              {ele._id !== "" &&
                                <div className="dropdown">
                                  <button
                                    className="border-0 bg-white"
                                    type="button"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <i className="bi bi-three-dots-vertical"></i>
                                  </button>
                                  <ul className="dropsCateg dropdown-menu">
                                    <li>
                                      <a className="dropdown-item">
                                        <p
                                          className="p-0 m-0 text-orange"
                                          onClick={() =>
                                            toggleIsLoading(ele.category, index)
                                          }
                                          data-bs-toggle="modal"
                                          data-bs-target="#category"
                                        >Edit</p>
                                      </a>
                                    </li>
                                    <li>
                                    {filteredCategory.length >2 && <a className="dropdown-item" >
                                        <p
                                          className="p-0 m-0 text-orange"
                                          onClick={(e) =>
                                            editDelete("delete", index)
                                          }
                                        >Delete</p>
                                      </a>}
                                    </li>
                                  </ul>
                                </div>}
                              {/* <i className='fa fa-edit text-orange' onClick={() => toggleEditDelete(true, index)} ></i> &nbsp;
                            <i className="fa fa-trash fa-lg text-orange" onClick={(e) => editDelete("delete", index)}></i> */}
                              <p></p>
                            </div>
                          </>
                        );
                      })}
                  </div>
                </div>
                {/* details */}
              </nav>
              {/* Page Content  */}
              <div id="content" className="com-bsl" style={{ marginTop: "0", marginRight: "0" }}>
                <nav className="navbar navbar-expand-lg  bg-lgrey px-2">
                  <div className="container-fluid p-0">
                    <p className="text-orange boldnormal-p m-0">
                      {stage && stage.category ? capitalizeFirstLetter(stage.category) : ""}
                    </p>
                    <div className="vr m-3" />
                    {/* <a href className="d-flex align-items-center"><svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} fill="currentColor" className="bi bi-share-fill text-blue" viewBox="0 0 16 16">
                      <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z" />
                    </svg>
                      <p className="px-2 m-0">Share</p>
                    </a> */}
                    <div className=" dropdown ">
                      {/* <a className="dropdown-toggle  d-flex three-dot-drop" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                        <p className=" m-0  "><svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="currentColor" className="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                          <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                        </svg></p>
                      </a> */}
                      <ul className="dropdown-menu dropdown-menu-end dropdown-menu-lg-start ">
                        <li>
                          <a className="dropdown-item">
                            Rename
                          </a>
                        </li>
                        <li>
                          <a className="dropdown-item text-danger">
                            Delete
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className="gap-2 menNavInto">
                      <button
                        className="mainbtn actYuas"
                        type="button"
                        data-bs-toggle="offcanvas" data-bs-target="#sidecnvs" aria-controls="offcanvasExample"
                        style={{ lineHeight: "1", padding: "6px 14px" }}
                      >
                        <i className="bi bi-list" style={{ fontSize: "26px" }}></i>
                      </button>
                      <button
                        className="navbar-toggler mainbtn actYuas"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 6.35 6.35" id="expand"><g color="#fff" fontFamily="sans-serif" fontWeight={400}><path fill="#ffffff" d="M.767 291.18a.264.264 0 0 0-.238.263v1.058a.264.264 0 0 0 .529 0v-.792h.792a.265.265 0 1 0 0-.53H.793a.264.264 0 0 0-.026 0zm1.349 1.062a.529.529 0 0 0-.525.524v2.122c0 .287.238.524.525.524h2.122a.529.529 0 0 0 .524-.524v-2.122a.529.529 0 0 0-.524-.524zm3.437 2.638a.264.264 0 0 0-.26.27v.792h-.794a.264.264 0 1 0 0 .529h1.058a.264.264 0 0 0 .264-.264v-1.058a.264.264 0 0 0-.268-.27z" overflow="visible" style={{ lineHeight: 'normal', fontVariantLigatures: 'normal', fontVariantPosition: 'normal', fontVariantCaps: 'normal', fontVariantNumeric: 'normal', fontVariantAlternates: 'normal', fontFeatureSettings: 'normal', textIndent: 0, textAlign: 'start', textDecorationLine: 'none', textDecorationStyle: 'solid', textDecorationColor: '#000', textTransform: 'none', textOrientation: 'mixed', shapePadding: 0, isolation: 'auto', mixBlendMode: 'normal' }} transform="translate(0 -290.65)" /><path fill="#c3c3c3" d="M.767 291.18a.264.264 0 0 0-.238.263v1.058a.264.264 0 0 0 .529 0v-.792h.792a.265.265 0 1 0 0-.53H.793a.264.264 0 0 0-.026 0zm1.349 1.062a.529.529 0 0 0-.525.524v2.122c0 .287.238.525.525.525h2.122a.529.529 0 0 0 .525-.525v-2.122a.529.529 0 0 0-.525-.524zm.004.528h2.114v2.114H2.12Zm3.433 2.11a.264.264 0 0 0-.261.27v.792h-.793a.264.264 0 1 0 0 .529h1.058a.264.264 0 0 0 .264-.264v-1.058a.264.264 0 0 0-.268-.27z" overflow="visible" style={{ lineHeight: 'normal', fontVariantLigatures: 'normal', fontVariantPosition: 'normal', fontVariantCaps: 'normal', fontVariantNumeric: 'normal', fontVariantAlternates: 'normal', fontFeatureSettings: 'normal', textIndent: 0, textAlign: 'start', textDecorationLine: 'none', textDecorationStyle: 'solid', textDecorationColor: '#000', textTransform: 'none', textOrientation: 'mixed', shapePadding: 0, isolation: 'auto', mixBlendMode: 'normal' }} transform="translate(0 -290.65)" /></g></svg>
                        {/* <span className="navbar-toggler-icon" /> */}
                      </button>
                    </div>
                    <div
                      className="collapse navbar-collapse justify-content-between"
                      id="navbarSupportedContent"
                    >
                      <div className="my-2 d-flex justify-content-around align-items-center ">
                        <select
                          className="form-select survey-op"
                          aria-label="Default select example"
                          onChange={(e) => SetActive(e.target.value)}
                        >
                          <option hidden>Active Survey</option>
                          <option value="active">Active</option>
                          <option value="inactive">InActive</option>
                          <option value="complete">Complete</option>
                        </select>
                        {/* <select className="form-select survey-op" aria-label="Default select example">
                          <option selected>Date Created</option>
                          <option value="1">One</option>
                          <option value="2">Two</option>
                          <option value="3">Three</option>
                        </select> */}
                        <input
                          className="form-select survey-op"
                          aria-label="Default select example"
                          type="date"
                          onChange={(e) => CreatedDate(e.target.value)}
                          name="birthday"
                        ></input>
                        {/* <li className="nav-item dropdown admin-drop">
                            <a className="nav-link dropdown-toggle d-flex align-items-center justify-content-between bg-white border px-2 m-2" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                              <p className=" m-0 admin-drop-p py-1">Date Created</p>
                            </a>
                            <ul className="dropdown-menu dropdown-menu">
                              <li><a className="dropdown-item" href="#">Action</a></li>
                              <li><a className="dropdown-item" href="#">Another action</a></li>
                              <li><a className="dropdown-item" href="#">Something else here</a></li>
                            </ul>
                          </li> */}
                      </div>
                      <ul className="nav navbar-nav layout-admin">
                        <ul
                          className="nav nav-tabs border-0 justify-content-center"
                          id="myTab"
                          role="tablist"
                        >
                          <li className="nav-item mr-2" role="presentation">
                            <button
                              type="button"
                              className="mainbtn mainbtsase"
                              onClick={() => parentToChild()}
                            >
                              Try Report
                            </button>
                          </li>
                          <li className="nav-item mr-2" role="presentation">
                            <button
                              className="nav-link"
                              id="profile-tab"
                              data-bs-toggle="tab"
                              onClick={(e) => setGrid(0)}
                              data-bs-target="#profile-tab-pane"
                              type="button"
                              role="tab"
                              aria-controls="profile-tab-pane"
                              aria-selected="false"
                            >
                              <img
                                src="../images/Icon ionic-md-list.svg"
                                alt=""
                              />
                              List
                            </button>
                          </li>
                          <li className="nav-item" role="presentation">
                            <button
                              className="nav-link active"
                              id="home-tab"
                              data-bs-toggle="tab"
                              onClick={(e) => setGrid(1)}
                              data-bs-target="#home-tab-pane"
                              type="button"
                              role="tab"
                              aria-controls="home-tab-pane"
                              aria-selected="true"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={16}
                                height={16}
                                fill="currentColor"
                                className="bi bi-grid-3x3-gap-fill"
                                viewBox="0 0 16 16"
                              >
                                <path d="M1 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2zM1 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V7zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V7zM1 12a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2zm5 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2z" />
                              </svg>
                              Grid
                            </button>
                          </li>
                        </ul>
                      </ul>
                    </div>
                  </div>
                </nav>
                {userData && userData.is_client === 0 ?
                  <div className="w-100 bg-lgrey p-2">
                    <button
                      className="mainbtn "
                      data-bs-toggle="modal" data-bs-target="#create-survey-modal-options"
                    >
                      Create Survey
                    </button>
                  </div> : (userData.is_client === 1) ?
                    <div className="w-100 bg-lgrey p-2">
                      <button
                        className="mainbtn "
                        data-bs-toggle="modal" data-bs-target="#from-scratch-modal03"
                      >
                        Create client Survey
                      </button>
                    </div> :
                    <div className="w-100 bg-lgrey p-2">
                      <button
                        className="mainbtn "
                        data-bs-toggle="modal" data-bs-target="#create-survey-modal-options"
                      >
                        Create Survey
                      </button>
                    </div>}
                {/* data-bs-toggle="modal" data-bs-target="#create-survey-modal" */}
                <div className="surveys-bar px-3  bg-white com-bsl boxShgya">
                  <div className="tab-content" id="myTabContent">
                    {Suvrey?.length !== 0 ? (
                      <div className="layout-grid-content justify-content-center">
                        <div className="">
                          {grid === 1 ? (
                            <div className="">
                              <div className="row huanRex">
                                {Suvrey.map((e, index) => (
                                  <div key={index} className="col-md-4 my-3">
                                    <div className="card ContentTap1 h-100">
                                      {e?.saved == 1 && <div className='tagItem'><small>Saved</small></div>}
                                      {/* <button className="border-0 bg-white" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                      <i className="bi bi-three-dots-vertical"></i>
                                    </button> */}
                                      <div className="dropdown">
                                        <button className="border-0 bg-white" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                          <i className="bi bi-three-dots-vertical"></i>
                                        </button>
                                        <ul className="dropsCateg dropdown-menu">
                                          <li>
                                            <a className=" dropdown-item" data-bs-toggle="modal"
                                              data-bs-target="#from-scratch-modal" onClick={() => editSurveyDetails(e)}>
                                              Edit
                                            </a>
                                          </li>
                                          <li>
                                            <a className=" dropdown-item" onClick={() => addDasgboard(e)}>
                                              Duplicate
                                            </a>
                                          </li>
                                          <li>
                                            <a className=" dropdown-item" onClick={(euikiu) => deleteSurvey(e._id, index)}>
                                              Delete
                                            </a>
                                          </li>
                                          <li>
                                            <a className="dropdown-item" onClick={(q) => setMovetoCategory(e)} data-bs-toggle="modal" data-bs-target="#exampleModalCenter">
                                              Move to
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                      <div className="UnnderItems text-center">
                                        <img
                                          src="../images/Surve1.png"
                                          alt="Img"
                                        />
                                        <h4
                                          className="text-orange mb-1"
                                          style={{ cursor: "Pointer" }}
                                          onClick={(event) => SetSuvrey(e._id)}
                                        >
                                          {capitalizeFirstLetter(e.survey_name)}
                                        </h4>
                                        <p className="mb-0">
                                          Question{" "}
                                          <span>: {e.questions.length}</span>
                                        </p>
                                        <p className="mb-0">
                                          Date{" "}
                                          <span>
                                            :{" "}
                                            {moment(e.date).format("MMM Do YYYY")}
                                          </span>
                                        </p>
                                      </div>
                                      {e.audience !== "Own Audience" ? (
                                        <div className="UnnderItems UnderSamers h-100">
                                          <div className="pps justify-content-center h-100 align-items-center d-flex border-top text-secondary">
                                            <div className="m-3 play_button">
                                              <i
                                                className="fs-3 bi bi-play-fill"
                                                style={
                                                  e.status === "active"
                                                    ? { color: "#16eb16" }
                                                    : {}
                                                }
                                                onClick={(ee) =>
                                                  changeSurveyStatus(
                                                    {
                                                      id: e._id,
                                                      status: "active",
                                                    },
                                                    index
                                                  )
                                                }
                                              ></i>
                                            </div>
                                            <div className="m-3  pause_button">
                                              <i
                                                className="fs-3 bi bi-pause-fill"
                                                style={
                                                  e.status === "inactive"
                                                    ? { color: "#ffc00f" }
                                                    : {}
                                                }
                                                onClick={(ee) =>
                                                  changeSurveyStatus(
                                                    {
                                                      id: e._id,
                                                      status: "inactive",
                                                    },
                                                    index
                                                  )
                                                }
                                              ></i>
                                            </div>
                                            <div className="m-3  stay_button">
                                              <i
                                                className="fs-3 bi bi-stop-fill"
                                                style={
                                                  e.status === "complete"
                                                    ? { color: "#ff0000" }
                                                    : {}
                                                }
                                                onClick={(ee) =>
                                                  changeSurveyStatus(
                                                    {
                                                      id: e._id,
                                                      status: "complete",
                                                    },
                                                    index
                                                  )
                                                }
                                              ></i>
                                            </div>
                                          </div>
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  </div>
                                ))}
                              </div>
                              <div className="d-flex justify-content-evenly mb-4">
                                {pageCount > 0 && <div><button className='btn btn-secondary me-3 bg-blue border-0' onClick={() => sendPageCount("back")}><i className="fa fa-arrow-left"></i></button></div>}
                                {pagination / pageCount >= 10 && Suvrey.length >= 9 && <div><button className='btn btn-secondary bg-blue border-0' onClick={() => sendPageCount("next")}><i className="fa fa-arrow-right"></i></button></div>}
                              </div>
                            </div>
                          ) : (
                            <div className="">
                              <div className="d-flex flex-wrap gap-3 pb-3 justufy-content-center">
                                <div className="w-100">
                                  <thead
                                    className="CollapGrounp"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#groupItem1"
                                    aria-expanded="true"
                                    aria-controls="groupItem1"
                                  >
                                    <tr className="text-left text-default bg-light-green">
                                      <th colspan="5" style={{ width: "84%" }}>
                                        <span className="d-flex align-items-center position-relative">
                                          <span>Survey</span>
                                        </span>
                                      </th>
                                      <th colspan="5">
                                        <span className="d-flex align-items-center position-relative">
                                          <span>Question</span>
                                        </span>
                                      </th>
                                    </tr>
                                  </thead>
                                </div>
                                {Suvrey?.map((e, index) => (
                                  <div key={index} className="card ContentTap1 ContentTap2">
                                    <div className="UnnderItems text-left">
                                      <img
                                        src="../images/Surve1.png"
                                        alt="Img"
                                      />
                                    </div>
                                    <div
                                      className="UnnderItemrr text-left "
                                      style={{ cursor: "Pointer" }}
                                      onClick={(event) => SetSuvrey(e._id)}
                                    >
                                      <h4 className="text-orange mb-1 mt-0">
                                        {capitalizeFirstLetter(e.survey_name)}
                                      </h4>
                                      <p className="mb-0">
                                        Created{" "}
                                        <span>
                                          :{" "}
                                          {moment(e.date).format("MMM Do YYYY")}
                                        </span>
                                      </p>
                                      {/* <p className="mb-0">Last Update <span>: Mar 28th 2023</span>
                                     </p> */}
                                    </div>
                                    {/* <span className='edPerce' ></span> */}
                                    <span>{e.questions.length}</span>
                                    {/* <span className='edPerce'>50%</span> */}
                                    {e.audience !== "Own Audience" ? (
                                      <div className="UnnderItems UnderSamers h-100">
                                        <div className="pps justify-content-center h-100 align-items-center d-flex text-secondary">
                                          <div
                                            className="m-3 "
                                            style={{ cursor: "Pointer" }}
                                          >
                                            <i
                                              className="fs-3 bi bi-play-fill"
                                              style={
                                                e.status === "active"
                                                  ? { color: "#16eb16" }
                                                  : {}
                                              }
                                              onClick={(ee) =>
                                                changeSurveyStatus(
                                                  {
                                                    id: e._id,
                                                    status: "active",
                                                  },
                                                  index
                                                )
                                              }
                                            />
                                          </div>
                                          <div
                                            className="m-3  "
                                            style={{ cursor: "Pointer" }}
                                          >
                                            <i
                                              className="fs-3 bi bi-pause-fill"
                                              style={
                                                e.status === "inactive"
                                                  ? { color: "#ffc00f" }
                                                  : {}
                                              }
                                              onClick={(ee) =>
                                                changeSurveyStatus(
                                                  {
                                                    id: e._id,
                                                    status: "inactive",
                                                  },
                                                  index
                                                )
                                              }
                                            />
                                          </div>
                                          <div
                                            className="m-3  "
                                            style={{ cursor: "Pointer" }}
                                          >
                                            <i
                                              className="fs-3 bi bi-stop-fill"
                                              style={
                                                e.status === "complete"
                                                  ? { color: "#ff0000" }
                                                  : {}
                                              }
                                              onClick={(ee) =>
                                                changeSurveyStatus(
                                                  {
                                                    id: e._id,
                                                    status: "complete",
                                                  },
                                                  index
                                                )
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                    {/* <button>
                                      <i className="bi bi-three-dots-vertical" />
                                    </button> */}
                                    <div className="dropdown">
                                      <button className="border-0 bg-white" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        <i className="bi bi-three-dots-vertical"></i>
                                      </button>
                                      <ul className="dropsCateg dropdown-menu">
                                        <li>
                                          <a className="text-orange dropdown-item" data-bs-toggle="modal"
                                            data-bs-target="#from-scratch-modal">
                                            Edit
                                          </a>
                                        </li>
                                        <li>
                                          <a className="text-orange dropdown-item" onClick={(euikiu) => deleteSurvey(e._id,index)}>
                                            Delete
                                          </a>
                                        </li>
                                        <li>
                                          <a className="text-orange dropdown-item">
                                            Move to
                                          </a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div
                        className="tab-pane fade show active  layout-grid"
                        id="home-tab-pane"
                        role="tabpanel"
                        aria-labelledby="home-tab"
                        tabIndex={0}
                      >
                        <div className="layout-grid-content d-flex justify-content-center">
                          <lottie-player
                            src="../images/a5afec80-d37c-40cf-a91f-0c346cd2d996.json"
                            background="transparent"
                            speed={1}
                            style={{ width: "30%", height: "30%" }}
                            loop
                            autoPlay
                          />
                        </div>
                        <div className="grid-content w-100 text-center pb-5">
                          <h5 className="text-orange">
                            Come on in, {userData && userData.fullName}
                          </h5>
                          <p className="pb-3">
                            It's time to create something special.
                          </p>
                          {/* <button
                            className="mainbtn "
                            data-bs-toggle="modal"
                            data-bs-target="#create-survey-modal"
                          >
                            Create Survey
                          </button> */}
                          {userData && userData.is_client === 0 ?
                            <div className="w-100 bg-lgrey p-2">
                              <button
                                className="mainbtn "
                                data-bs-toggle="modal" data-bs-target="#create-survey-modal-options"
                              >
                                Create Survey
                              </button>
                            </div> : (userData.is_client === 1) ?
                              <div className="w-100 bg-lgrey p-2">
                                <button
                                  className="mainbtn "
                                  data-bs-toggle="modal" data-bs-target="#from-scratch-modal03"
                                >
                                  Create client Survey
                                </button>
                              </div> : <div className="w-100 bg-lgrey p-2">
                                <button
                                  className="mainbtn "
                                  data-bs-toggle="modal" data-bs-target="#create-survey-modal-options"
                                >
                                  Create Survey
                                </button>
                              </div>}
                        </div>
                      </div>
                    )}
                    {/* <div className="tab-pane fade  layout-list" id="profile-tab-pane" role="tabpanel" aria-labelledby="profile-tab" tabIndex={0}>Hi content in list here</div> */}
                  </div>
                </div>
              </div>
            </div>
            {/* modals */}
            <div className="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLongTitle">{movetoCategory?.survey_name}</h5>
                    <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  {/* <div className="modal-body">
                    <div className="dropdown">
                      <h6>Category-{movetoCategory.category_id===undefined?"Not Available":capitalizeFirstLetter(getNameById(movetoCategory.category_id,surveycategory))}</h6>
                      <button className="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false" >
                        Select Category
                      </button>
                      <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                        <li><a className="dropdown-item" > {surveycategory &&
                          surveycategory.map((e) => (
                            <option  onClick={()=>moveSurvey(e)}>{capitalizeFirstLetter(e.category)}</option>
                          ))}</a></li>
                      </ul>
                    </div>
                  </div> */}
                  <div className="row">
                    <div className="col-md-6">
                      <h5 style={{ margin: "0 20px" }}>Category-{movetoCategory.category_id === undefined ? "Not Available" : capitalizeFirstLetter(getNameById(movetoCategory.category_id, surveycategory))}</h5>
                      <br></br>
                      <select
                        className="form-select survey-op"
                        aria-label="Default select example"
                        onChange={(e) => setSelectedCategory(e.target.value)}
                      >
                        <option >Select Category</option>
                        {surveycategory &&
                          surveycategory.map((e, index) => (
                            <option key={index} value={e._id}>{capitalizeFirstLetter(e.category)}</option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={() => moveSurvey()}>Save changes</button>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="modal survey-popup"
              id="create-survey-modal"
              tabIndex={-1}
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog createImportesurvey create-survey-modal modal-dialog-scrollable">
                <div className="modal-content">
                  <div className="modal-header d-flex align-items-center">
                    <h5 className="modal-title" id="exampleModalLabel">
                      Create a new survey
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      ref={templatePopup}
                    />
                  </div>
                  <div className="modal-body pb-4 pt-2">
                    <div className="row">
                      <div className="col-md-3">
                        <div
                          className="card bg-lgrey bg-gray-card-border text-center"
                          type="button"
                          data-bs-toggle="modal"
                          data-bs-target="#from-scratch-modal"
                          onClick={editSurveyDetails}
                        >
                          <lottie-player
                            src="../images/85b866aa-4863-4db0-8817-b61c399de968.json"
                            background="transparent"
                            speed={1}
                            style={{ width: "12.5rem", height: "12.5rem" }}
                            loop
                            autoPlay
                          />
                          <div className="card-body p-3 text-center">
                            <h5 className="card-title">Start from scratch</h5>
                            <p className="card-text">
                              Jump right in and build something beautiful
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3" onClick={(e) => navigateToTemplate()}>
                        <div className="card bg-lgrey bg-gray-card-border "
                        >
                          <lottie-player
                            src="../images/1c33fc10-e7d9-497c-9765-43d68895b665.json"
                            background="transparent"
                            speed={1}
                            style={{ width: "12.5rem", height: "12.5rem" }}
                            loop
                            autoPlay
                          />
                          <div className="card-body p-3 text-center"
                            type="button"
                            data-bs-toggle="modal"
                          >
                            <h5 className="card-title" >Use a template</h5>
                            <p className="card-text">
                              Pick a premade survey and customize it as you
                              please
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="card bg-lgrey bg-gray-card-border" type="button" data-bs-toggle="modal" data-bs-target="#importSurveys">
                          <lottie-player
                            src="../images/1c33fc10-e7d9-497c-9765-43d68895b665.json"
                            background="transparent"
                            speed={1}
                            style={{ width: "12.5rem", height: "12.5rem" }}
                            loop
                            autoPlay
                          />
                          <div className="card-body p-3 text-center">
                            <h5 className="card-title">Import your questions</h5>
                            <p className="card-text">
                              Pick a premade survey and customize it as you
                              please
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div
                          className="card bg-lgrey bg-gray-card-border text-center"
                          type="button"
                          data-bs-toggle="modal"
                          data-bs-target="#from-scratch-modal02"
                        >
                          <lottie-player
                            src="../images/67ea5ba5-92b0-4d1b-81b9-f0b09b98f6f5.json"
                            background="transparent"
                            speed={1}
                            style={{ width: "12.5rem", height: "12.5rem" }}
                            loop
                            autoPlay
                          />
                          <div className="card-body p-3 text-center">
                            <h5 className="card-title">Create it for me</h5>
                            <p className="card-text">
                              Tell us what you need and we will generate a
                              survey based on that
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Import Survey modal */}
            {/* scratch modal */}
            <div
              className="modal fade survey-popup"
              id="from-scratch-modal"
              data
              tabIndex={-1}
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            //  style={{display:"block", opacity:"1"}}
            >
              <div className="modal-dialog h-100">
                <div className="modal-content">
                  <div className="modal-header pb-0">
                    <h5 className="modal-title" id="exampleModalLabel">
                      Create a new survey
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      ref={closeModel}
                      onClick={closeButton}
                    />
                  </div>
                  <Form
                  ref={formRef}
                    name="normal_login"
                    className="login-form"
                    initialValues={{ remember: true }}
                    onFinish={(e) => addDasgboard()}
                  >
                    <div className="modal-body text-center arownew p-4 model-image-newsurvey">
                      <div className="surForm d-flex w-100 justify-content-between mb-3">
                        <div className="suresForm">
                          <label className="text-start">Survey Name</label>
                          <Form.Item
                            name="surveyname"
                            rules={[{ required: true, message: 'Please input your survey name!' }]}>
                            <Input
                              name="title"
                              type="text"
                              className="form-control"
                              defaultValue={surveyTitle}
                              onChange={(e) => setSurveyTitle(e.target.value)}
                              placeholder="Enter Survey Name"
                            />
                          </Form.Item>
                        </div>
                        {/* <lottie-player src="/../images/6c4fd321-e509-4d3a-a3ff-8da5bea55f10.json" background="transparent" speed={1} style={{ width: '250px', height: '250px' }} loop autoPlay /> */}
                        {
                          <div className="suresForm">
                            <label className="text-start">Expected Completes (in number)<span><i className="bi ms-2 bi-question-circle-fill"></i><span className="quesnmsw">Expected total responses</span></span></label>
                            <Form.Item
                              name="expectedcompletes"
                              rules={[{ required: true, message: 'Please input your expected completes!' }]}>
                              <Input
                                type="number"
                                className="form-control"
                                defaultValue={exCompletes}
                                onChange={(e) => setExCompletes(e.target.value)}
                                placeholder="Number Type"
                              />
                            </Form.Item>
                          </div>
                        }
                      </div>
                      <div className="surForm d-flex w-100 justify-content-between mb-3">
                        <div className="suresForm">
                          <label className="text-start">Survey Audience<span><i className="bi ms-2 bi-question-circle-fill"></i><span className="quesnmsw"> select the target audience for the survey</span></span></label>
                          <Form.Item
                            name="surveyaudience"
                            rules={[{ required: true, message: 'Please select your audience!' }]}>
                            <select
                              className="form-control survey_border border-white"
                              value={audience}
                              onChange={(e) => setAudienceHandle(e.target.value)}
                              placeholder="Survey Category"
                            >
                              <option value="" hidden>Select Audience</option>
                              <option value="Buy Audience">Buy Audience</option>
                              <option value="My Own Audience">
                                My Own Audience
                              </option>
                            </select>
                          </Form.Item>
                        </div>
                        <div className="suresForm">
                          <label className="text-start">
                            Expected Completion LOI (in minutes)<span><i className="bi ms-2 fs-7 bi-question-circle-fill"></i><span className="quesnmsw">Length of interview</span></span>
                          </label>
                          <Form.Item
                            name="expectedcompletionloi"
                            rules={[{ required: true, message: 'Please input your  expected completion LOI !' }]}>
                            <Input
                              type="number"
                              className="form-control"
                              onChange={(e) => setExLOI(e.target.value)}
                              placeholder="Number Type"
                            />
                          </Form.Item>
                        </div>
                      </div>
                      <div className="surForm d-flex w-100 justify-content-between mb-3">
                        <div className="suresForm">
                          <label className="text-start">Survey Category<span><i className="bi ms-2 bi-question-circle-fill"></i><span className="quesnmsw">select the category for which this survey will be created</span></span></label>
                          <Form.Item
                            name="surveycategory"
                            rules={[{ required: true, message: 'Please input your survey category!' }]}>
                            <select
                              className="form-control survey_border border-white"
                              value={surveyCategoru}
                              onChange={(e) => setSurveyCategory(e.target.value)}
                              placeholder="Survey Category"
                            >
                              <input
                                type="number"
                                className="form-control"
                                onChange={(e) => setExIncidence(e.target.value)}
                                placeholder="Edit survey category name"></input>
                              <option value="" hidden>Select Category</option>
                              {surveycategory &&
                                surveycategory.map((e, index) => (
                                  <option key={index} value={e._id}>{e.category}</option>
                                ))}
                            </select>
                          </Form.Item>
                        </div>
                        {(audience == "Buy Audience") ? <div className="suresForm">
                          <label className="text-start">
                            Expected Incidence Rate<span><i className="bi ms-2 bi-question-circle-fill"></i><span className="quesnmsw">The percentage of respondents that will qualify for the study after basic demographic targeting.</span></span>
                          </label>
                          <Form.Item
                            name=" expectedincidencerate"
                            rules={[{ required: true, message: 'Please input your  expected incidence rate!' }]}>
                            <Input
                              type="number"
                              className="form-control"
                              onChange={(e) => setExIncidence(e.target.value)}
                              placeholder="Number Type"
                            />
                          </Form.Item>
                        </div> : null}
                      </div>
                      <div className="surForm d-flex w-100 justify-content-between mb-3">
                        {<div className={access && access.Digital_Survey_Type && access.Digital_Survey_Type[0] && access.Digital_Survey_Type[0].Vernacular_Survey == "No" ? "suresForm tooltip" : "suresForm"}>
                          <label className="text-start">Languages {access && access.Digital_Survey_Type && access.Digital_Survey_Type[0] && access.Digital_Survey_Type[0].Vernacular_Survey == "No" && <i className="bi bi-lock-fill"></i>}</label>
                          <form className="form-group w-100">
                            <Form.Item
                            >
                              <Multiselect
                                className="survey_border border-white"
                                disablePreSelectedValues={true}
                                disable={access && access.Digital_Survey_Type && access.Digital_Survey_Type[0] && access.Digital_Survey_Type[0].Vernacular_Survey == "No"}
                                selectedValues={[lang[0]]}
                                isObject={false}
                                onRemove={(e) => SelectLng(e, "setData")}
                                onSearch={(e) => SelectLng(e, "setData")}
                                onSelect={(e) => SelectLng(e, "setData")}
                                options={lang}
                                placeholder='Select Languages'
                              />
                              {access && access.Digital_Survey_Type && access.Digital_Survey_Type[0] && access.Digital_Survey_Type[0].Vernacular_Survey == "No" && <span className="tooltiptextt w-100 mb-5">Not Available in this Package,Upgrade First</span>}
                            </Form.Item>
                          </form>
                        </div>}
                        {<div className={access && access.Digital_Survey_Type && access.Digital_Survey_Type[0] && access.Digital_Survey_Type[0].Audio_Survey == 'No' ? "suresForm tooltip text-dark" : "suresForm"} >
                          <label className="text-start">Survey Audio {access && access.Digital_Survey_Type && access.Digital_Survey_Type[0] && access.Digital_Survey_Type[0].Audio_Survey == 'No' && <i className="bi bi-lock-fill"></i>}</label>
                          <form className="form-group lh-2 text-left w-100">
                            <label className="me-5 form-check-label" htmlFor="flexSwitchCheckDefault">Audio Required</label>
                            <input className="form-check-input" type="checkbox" role="switch"
                              disabled={access && access.Digital_Survey_Type && access.Digital_Survey_Type[0] && access.Digital_Survey_Type[0].Audio_Survey == 'No'} id="flexSwitchCheckDefault" onChange={(e) => setAudio(!audio)}
                            />
                          </form>
                          {access && access.Digital_Survey_Type && access.Digital_Survey_Type[0] && access.Digital_Survey_Type[0].Audio_Survey == 'No' && <span className="tooltiptextt w-100">Not Available in this Package,Upgrade First</span>}
                        </div>}
                      </div>
                      <Form.Item>
                        <Button htmlType="submit" className="mainbtn text-white">
                          Create Survey
                        </Button>
                      </Form.Item>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
            {/* scratch modal 3*/}
            <div
              className="modal fade survey-popup"
              id="from-scratch-modal02"
              tabIndex={-1}
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog choosingseew h-100  survey-title-modal">
                <div className="modal-content">
                  <div className="modal-header pb-0">
                    {/* <h5 className="modal-title" id="exampleModalLabel">Create a new survey</h5> */}
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    />
                  </div>
                  <div className="modal-body text-center arownew p-4 model-image-newsurvey">
                    <p className="m-0 p-0">Thank you choosing us.</p>
                    <p className="m-0 p-0">
                      Our team member will connect with you soon.
                    </p>
                    {/* <div className="text-center py-4" onClick={addDasgboard}>
                      <a className="mainbtn text-white" data-bs-dismiss="modal" aria-label="Close">Create Survey</a>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
            {/* scratch modal */}
            <div
              className="modal fade survey-popup"
              id="from-scratch-modal03"
              data
              tabIndex={-1}
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            //  style={{display:"block", opacity:"1"}}
            >
              <div className="modal-dialog h-100  survey-title-modal">
                <div className="modal-content">
                  <div className="modal-header pb-0">
                    <h5 className="modal-title" id="exampleModalLabel">
                      Create a new survey client
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      ref={closeModel2}
                    />
                  </div>
                  <Form
                    name="normal_login"
                    className="login-form"
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                  >
                    <div className="modal-body text-center arownew p-4 model-image-newsurvey">
                      <div className="surForm d-flex w-100 justify-content-between mb-3">
                        <div className="suresForm">
                          <label className="text-start">Survey Name</label>
                          <Form.Item
                            name="surveyname"
                            rules={[{ required: true, message: 'Please input your survey name!' }]}>
                            <Input
                              type="text"
                              className="form-control"
                              onChange={(e) => setSurveyTitle(e.target.value)}
                              placeholder="Enter Survey Name"
                            />
                          </Form.Item>
                        </div>
                        {/* <lottie-player src="/../images/6c4fd321-e509-4d3a-a3ff-8da5bea55f10.json" background="transparent" speed={1} style={{ width: '250px', height: '250px' }} loop autoPlay /> */}
                        {
                          <div className="suresForm">
                            <label className="text-start">Expected Completes (in number)<span><i className="bi ms-2 bi-question-circle-fill"></i><span className="quesnmsw">Expected total responses</span></span></label>
                            <Form.Item
                              name="expectedcompletes"
                              rules={[{ required: true, message: 'Please input your expected completes!' }]}>
                              <Input
                                type="number"
                                className="form-control"
                                onChange={(e) => setExCompletes(e.target.value)}
                                placeholder="Number Type"
                              />
                            </Form.Item>
                          </div>
                        }
                      </div>
                      <div className="surForm d-flex w-100 justify-content-between mb-3">
                        <div className="suresForm">
                          <label className="text-start">Survey Audience<span><i className="bi ms-2 bi-question-circle-fill"></i><span className="quesnmsw"> select the target audience for the survey</span></span></label>
                          <Form.Item
                            name="surveyaudience"
                            rules={[{ required: true, message: 'Please select your audience!' }]}>
                            <select
                              className="form-control survey_border border-white"
                              onChange={(e) => setAudienceHandle(e.target.value)}
                              placeholder="Survey Category"
                            >
                              <option default>Select Audience</option>
                              <option value="Buy Audience">Buy Audience</option>
                              <option value="My Own Audience">
                                My Own Audience
                              </option>
                            </select>
                          </Form.Item>
                        </div>
                        <div className="suresForm">
                          <label className="text-start">
                            Expected Completion LOI (in minutes)<span><i className="bi ms-2 fs-7 bi-question-circle-fill"></i><span className="quesnmsw">Length of interview</span></span>
                          </label>
                          <Form.Item
                            name="expectedcompletionloi"
                            rules={[{ required: true, message: 'Please input your  expected completion LOI !' }]}>
                            <Input
                              type="number"
                              className="form-control"
                              onChange={(e) => setExLOI(e.target.value)}
                              placeholder="Number Type"
                            />
                          </Form.Item>
                        </div>
                      </div>
                      <div className="surForm d-flex w-100 justify-content-between mb-3">
                        <div className="suresForm">
                          <label className="text-start">Survey Category<span><i className="bi ms-2 bi-question-circle-fill"></i><span className="quesnmsw">select the category for which this survey will be created</span></span></label>
                          <Form.Item
                            name="surveycategory"
                            rules={[{ required: true, message: 'Please input your survey category!' }]}>
                            <select
                              className="form-control survey_border border-white"
                              onChange={(e) => setSurveyCategory(e.target.value)}
                              placeholder="Survey Category"
                            >
                              <input
                                type="number"
                                className="form-control"
                                onChange={(e) => setExIncidence(e.target.value)}
                                placeholder="Edit survey category name"></input>
                              <option hidden>Select Category</option>
                              {surveycategory &&
                                surveycategory.map((e, index) => (
                                  <option key={index} value={e._id}>{e.category}</option>
                                ))}
                            </select>
                          </Form.Item>
                        </div>
                        <div className="suresForm">
                          <label className="text-start">
                            Survey Url<span><i className="bi ms-2 bi-question-circle-fill"></i><span className="quesnmsw">The percentage of respondents that will qualify for the study after basic demographic targeting.</span></span>
                          </label>
                          <Form.Item
                            name=" expectedincidencerate"
                            rules={[{ required: true, message: 'Please input your  Survey Url' }]}>
                            <Input
                              type=""
                              className="form-control"
                              onChange={(e) => setUrl(e.target.value)}
                              placeholder="URL"
                            />
                          </Form.Item>
                        </div>
                      </div>
                      <div className="surForm d-flex w-100 justify-content-between mb-3">
                        {/* {<div className={access && access.Digital_Survey_Type && access.Digital_Survey_Type[0] && access.Digital_Survey_Type[0].Vernacular_Survey == "No" ? "suresForm tooltip" : "suresForm"}>
                          <label className="text-start">Languages {access && access.Digital_Survey_Type && access.Digital_Survey_Type[0] && access.Digital_Survey_Type[0].Vernacular_Survey == "No" && <i className="bi bi-lock-fill"></i>}</label>
                          <form className="form-group w-100">
                            <Form.Item
                            >
                              <Multiselect
                                className="survey_border border-white"
                                disablePreSelectedValues={true}
                                disable={access && access.Digital_Survey_Type && access.Digital_Survey_Type[0] && access.Digital_Survey_Type[0].Vernacular_Survey == "No"}
                                selectedValues={[lang[0]]}
                                isObject={false}
                                onRemove={(e) => SelectLng(e, "setData")}
                                onSearch={(e) => SelectLng(e, "setData")}
                                onSelect={(e) => SelectLng(e, "setData")}
                                options={lang}
                                placeholder='Select Languages'
                              />
                              {access && access.Digital_Survey_Type && access.Digital_Survey_Type[0] && access.Digital_Survey_Type[0].Vernacular_Survey == "No" && <span className="tooltiptextt w-100 mb-5">Not Available in this Package,Upgrade First</span>}
                            </Form.Item>
                          </form>
                        </div>} */}
                        {/* {<div className={access && access.Digital_Survey_Type && access.Digital_Survey_Type[0] && access.Digital_Survey_Type[0].Audio_Survey == 'No' ? "suresForm tooltip text-dark" : "suresForm"} >
                          <label className="text-start">Survey Audio {access && access.Digital_Survey_Type && access.Digital_Survey_Type[0] && access.Digital_Survey_Type[0].Audio_Survey == 'No' && <i className="bi bi-lock-fill"></i>}</label>
                          <form className="form-group lh-2 text-left w-100">
                            <label className="me-5 form-check-label" htmlFor="flexSwitchCheckDefault">Audio Required</label>
                            <input className="form-check-input" type="checkbox" role="switch"
                              disabled={access && access.Digital_Survey_Type && access.Digital_Survey_Type[0] && access.Digital_Survey_Type[0].Audio_Survey == 'No'} id="flexSwitchCheckDefault" onChange={(e) => setAudio(!audio)}
                            />
                          </form>
                          {access && access.Digital_Survey_Type && access.Digital_Survey_Type[0] && access.Digital_Survey_Type[0].Audio_Survey === 'No' && <span className="tooltiptextt w-100">Not Available in this Package,Upgrade First</span>}
                          <span className="tooltiptextt w-100">Not Available in this Package,Upgrade First</span>
                        </div>} */}
                      </div>
                      <Form.Item>
                        <Button htmlType="submit" onClick={addDasgboardClient} className="mainbtn text-white"  >
                          Create Survey
                        </Button>
                      </Form.Item>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* private category pop up */}
        <div
          className="modal fade survey-popup"
          id="category"
          tabIndex={-1}
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog h-100  survey-title-modal">
            <div className="modal-content">
              <div className="modal-header pb-0">
                <h5 className="modal-title" id="exampleModalLabel">
                  Category
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body text-center arownew p-4 model-image-newsurvey">
                <label className="text-start">Survey Category</label>
                <input
                  type="text"
                  className="form-control"
                  value={addSurveyCategory}
                  onChange={(e) => setAddSurveyCategory(e.target.value)}
                  id="formGroupExampleInput"
                  autoComplete="off"
                />
                {/* <div className="text-center w-100"><button className="mainbtn mr-3 mb-2">Submit</button></div>? */}
                <div className="text-center py-4" onClick={(e) => survCat ? editDelete("edit", categoryIndex) : addsurveyCategory()}>
                  <a
                    className="mainbtn text-white"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    {survCat ? 'Update' : 'Submit'}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* private category pop up end*/}
        <div
          className="modal fade survey-popup"
          id="create-survey-modal-options"
          tabIndex={-1}
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog create-survey-modal">
            <div className="modal-content">
              <div className="modal-header d-flex align-items-center">
                <h5 className="modal-title" id="exampleModalLabel">
                  Select your survey platform
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  ref={surveyPopup}
                />
              </div>
              <div className=" py-3 row">
                <div className="col-lg-12">
                  {/* <select className="form-select p-3 rounded-0 w-100" aria-label="Default select example" onChange={(e) => setSurveyType(e.target.value)}>
                    <option value='digital'>Digital Surveys (CAWI)</option>
                    <option value="FGD">Focused Group Discussion (FGD)</option>
                    <option value="telephonic">Telephonic Interview (CATI)</option>
                    <option value="personal">Personal Interview (CAPI)</option>
                  </select> */}
                  <div className="dropdownnma survDropD">
                    <input
                      type="checkbox"
                      className="dropdown__switch"
                      id="filter-switch"
                      hidden
                    />
                    <label
                      htmlFor="filter-switch"
                      className="dropdown__options-filter mb-0"
                    >
                      <ul
                        className="dropdown__filter pe-5"
                        role="listbox"
                        tabIndex="-1"
                      >
                        <li
                          className="dropdown__filter-selected"
                          aria-selected="true"
                        >
                          {surveyType}
                        </li>
                        <li>
                          <ul className="dropdown__select">
                            <li
                              className="dropdown__select-option"
                              onClick={(e) =>
                                setSurveyType("Digital Surveys (CAWI)")
                              }
                              role="option"
                            >
                              Digital Surveys (CAWI)
                            </li>
                            <li
                              className="dropdown__select-option"
                              onClick={(e) =>
                                setSurveyType("Focused Group Discussion (FGD)")
                              }
                              role="option"
                            >
                              Focused Group Discussion (FGD)
                            </li>
                            <li
                              className="dropdown__select-option"
                              onClick={(e) =>
                                setSurveyType("Telephonic Interview (CATI)")
                              }
                              role="option"
                            >
                              Telephonic Interview (CATI)
                            </li>
                            <li
                              className="dropdown__select-option"
                              onClick={(e) =>
                                setSurveyType("Personal Interview (CAPI)")
                              }
                              role="option"
                            >
                              Personal Interview (CAPI)
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </label>
                  </div>
                </div>
                {/* <div className="row py-2"> */}
                <div className="col-sm-6">
                  <div className="text-center p-3 w-100 h-100">
                    {surveyType == "Digital Surveys (CAWI)" && (
                      <img src="../images/Digital.png" width={"100%"}></img>
                    )}
                    {surveyType == "Focused Group Discussion (FGD)" && (
                      <img
                        src="../images/Mask Group 37.png"
                        width={"100%"}
                      ></img>
                    )}
                    {surveyType == "Telephonic Interview (CATI)" && (
                      <img src="../images/Telephonic.png" width={"100%"}></img>
                    )}
                    {surveyType == "Personal Interview (CAPI)" && (
                      <img src="../images/personal.png" width={"100%"}></img>
                    )}
                  </div>
                </div>
                <div className="col-sm-6 d-flex align-items-center">
                  {/* <div className="text-center"> */}
                  {surveyType == "Digital Surveys (CAWI)" && (
                    <div className="text-left px-3">
                      <h5 className="card-title mt-0">Digital Surveys</h5>
                      <p className="card-text">
                        Digital surveys are easy to conduct and provide
                        immediate access to intelligence while remaining
                        cost-effective. As more people get connected to the
                        internet, digital surveys provide unprecedented access
                        to this online population. It is the most popular form
                        of research amongst our clients.
                      </p>
                    </div>
                  )}
                  {surveyType == "Focused Group Discussion (FGD)" && (
                    <div className="card-body px-3 py-0 text-left">
                      <h5 className="card-title mt-0">
                        Focused Group Discussion
                      </h5>
                      <p className="card-text">
                        With a skilled moderator, we bring in qualified
                        panelists from your target market to help you unlock
                        qualitative insights fast. You get to hear customer
                        feedback in their own words and voices.
                      </p>
                    </div>
                  )}
                  {surveyType == "Telephonic Interview (CATI)" && (
                    <div className="card-body px-3 py-0 text-left">
                      <h5 className="card-title mt-0">Telephonic Interviews</h5>
                      <p className="card-text">
                        (Australia, Singapore, UAE, Saudi Arabia, Qatar, Oman,
                        Kuwait, Bahrain) - Our telephonic interviews provide you
                        with direct access to respondents around the globe. You
                        can easily connect with your target audience in a
                        multitude of countries to get the answers you need.
                      </p>
                    </div>
                  )}
                  {surveyType == "Personal Interview (CAPI)" && (
                    <div className="card-body px-3 py-0 text-left">
                      <h5 className="card-title mt-0">Personal Interviews</h5>
                      <p className="card-text">
                        Best suited for qualitative research, personal
                        interviews give you the opportunity to gain deeper
                        insights into your consumer base. This form of research
                        comes in handy when detailed answers and in-depth
                        insights are needed to power your study.
                      </p>
                    </div>
                  )}
                </div>
                <div className="text-center mt-3 p-2">
                  {surveyType === "Digital Surveys (CAWI)" && (
                    <a
                      className="mainbtn text-white"
                      data-bs-toggle="modal"
                      data-bs-target="#create-survey-modal"
                    >
                      Submit
                    </a>
                  )}
                  {surveyType === "Focused Group Discussion (FGD)" && (
                    <a htmlType="submit"
                      className="mainbtn text-white"
                      onClick={(e) => fgd()}
                    >
                      Submit
                    </a>
                  )}
                  {surveyType !== "Digital Surveys (CAWI)" && surveyType !== "Focused Group Discussion (FGD)" && (
                    <a
                      className="mainbtn text-white"
                      data-bs-toggle="modal"
                      data-bs-target="#from-scratch-modal02"
                    >
                      Submit
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* {surveyTitle &&
          <Scratchsurvey surveyTitle={surveyTitle} />
        } */}
      </section>
      <ToastContainer autoClose={1000} hideProgressBar={true} />
      <>
        {/* <Modal
          show={categoryIndex || categoryIndex == 0 ? true : false}
          onHide={toggleEditDelete}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Edit Survey Category Name{" "}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <input
              className="surveyEdit543"
              value={categoryName ? categoryName : ""}
              onChange={(e) => setCategoryName(e.target.value)}
              type="text"
            />
          </Modal.Body>
          <Modal.Footer>
            <button
              className="mainbtn"
              onClick={(e) => editDelete("edit", categoryIndex)}
            >
              Submit
            </button>
          </Modal.Footer>
        </Modal> */}
      </>
      <div
        className="card bg-lgrey bg-gray-card-border text-center"
        type="button"
        ref={buttonRef}
        data-bs-toggle="modal"
        data-bs-target="#from-scratch-modal03"
        data-backdrop="static" data-keyboard="false"
      />
      {plan_days == 0 && <div
        className="modal fade survey-popup"
        id="from-scratch-modal03"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      // tabindex="-1"
      >
        <div className="modal-dialog choosingseew h-100 survey-title-modal">
          <div className="modal-content">
            <div className="modal-header pb-0">
              {/* <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              /> */}
            </div>
            <div className="modal-body  text-center arownew p-4 model-image-newsurvey">
              <div className="titleExpire">
                <h5 className="fs-1 text-blue fw-light">Your trial has expired.</h5>
                <p className="text-black-50">We hope you enjoyed your trial. Please choose any one of the options to proceed.</p>
              </div>
              <div className="bodyuExpire">
                {/* ------- */}
                <div className="contentExpire">
                  {/* <lottie-player src="../images/bitcoin-investment-loss.json"  background="transparent"  speed="1"  style="width: 300px; height: 300px;"  loop controls autoplay></lottie-player> */}
                  <Lottie options={defaultOptions1}
                    height={200}
                    width={200}
                    style={{ marginTop: "-100px" }}
                  // isStopped={this.state.isStopped}
                  // isPaused={this.state.isPaused}
                  />
                  <h4 className="text-blue">Extend Trial</h4>
                  <p className="text-black-50 mt-4">Need little more time to test drive?<br></br>Extend trial by another 5 days</p>
                  <a className="mainbtn">Continue</a>
                </div>
                {/* ------- */}
                <div className="contentExpire content23a">
                  {/* <img src="../images/" width="200px" alt="" /> */}
                  <Lottie options={defaultOptions2}
                    height={200}
                    width={200}
                    style={{ marginTop: "-100px" }}
                  // isStopped={this.state.isStopped}
                  // isPaused={this.state.isPaused}
                  />
                  <h4 className="text-white">Upgrade</h4>
                  <p className="text-white mt-4">Upgrade to a paid plan to collect<br></br>feedback & grow!</p>
                  <a className="mainbtn btnblue">Buy Now</a>
                </div>
                {/* ------- */}
                <div className="contentExpire">
                  {/* <img src="../images/" width="200px" alt="" /> */}
                  <Lottie options={defaultOptions3}
                    height={200}
                    width={200}
                    style={{ marginTop: "-100px" }}
                  // isStopped={this.state.isStopped}
                  // isPaused={this.state.isPaused}
                  />
                  <h4 className="text-blue">Cancel Account</h4>
                  <p className="text-black-50 mt-4">I no longer need this account. Please<br></br>cancel my account</p>
                  <a className="mainbtn">Cencel</a>
                </div>
                {/* ------- */}
              </div>
            </div>
          </div>
        </div>
      </div>}
      {/* <script src="https://unpkg.com/@lottiefiles/lottie-player@latest/dist/lottie-player.js"></script> */}
    </>
  );
}
export default Admindash;